module.exports = __webpack_public_path__ + "e42bef9d5394064bb9b154fc57e80503.svg";